import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	standalone: true,
	selector: 'wd-help-modal',
	template: `
		<div class="modal-header">
			<h5 class="modal-title">{{name}}</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<p *ngIf="text">{{text}}</p>
			<table *ngIf="list" class="table table-sm">
				<tbody>
					<tr *ngFor="let item of list">
						<td><strong>{{item.value}}</strong></td>
						<td>{{item.name}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	`,
	styles: [`
		.modal-body {
			padding: 1rem 1.5rem;
			max-height: 70vh;
			overflow-y: auto;
		}
	`],
	imports: [CommonModule]
})
export class HelpModalComponent {
	@Input() name!: string;
	@Input() text?: string;
	@Input() list?: {value: string, name: string}[];

	constructor(public activeModal: NgbActiveModal) {}
}
